import * as React from "react";
import { forwardRef } from "react";
const CircleCheckSVG = (props, ref) => React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", ref: ref, ...props },
    React.createElement("path", { fillRule: "evenodd", d: "M12 21.902c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10m5.764-13.355a1 1 0 1 0-1.528-1.29l-6.016 7.13-1.482-1.621a1 1 0 0 0-1.476 1.349l2.25 2.461a1 1 0 0 0 1.502-.03z", clipRule: "evenodd" }));
const ForwardRef = forwardRef(CircleCheckSVG);
export default ForwardRef;
//# sourceMappingURL=CircleCheck.js.map